export const QUNOMEDICAL_BRAND_ID = 'ZoYoIDxR4MkbKnMArUDam';
export const QUNOMEDICAL_DOMAIN = 'https://www.qunomedical.com';
